import React from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import seoContent1 from "../../../../assets/images/serviceImages/seoContent1.webp";
import seoContent2 from "../../../../assets/images/serviceImages/seoContent2.webp";

const SeoContentMarketingWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div className="w-full rounded-[16px] overflow-hidden h-[300px] sm:h-auto">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center"
            pagination={{
              type: "bullets",
              el: ".pagination-progress",
              clickable: true,
            }}
            autoplay={true}
            spaceBetween={20}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop
          >
            <SwiperSlide>
              <img
                src={seoContent1}
                className="rounded-[16px] w-full object-cover"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={seoContent2}
                className="rounded-[16px] w-full object-cover"
                alt=""
              />
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination pagination-progress"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default SeoContentMarketingWork;
